import { render, staticRenderFns } from "./9e_doc.vue?vue&type=template&id=44635190&scoped=true"
import script from "./9e_doc.vue?vue&type=script&lang=js"
export * from "./9e_doc.vue?vue&type=script&lang=js"
import style0 from "./9e_doc.vue?vue&type=style&index=0&id=44635190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44635190",
  null
  
)

export default component.exports